export enum NavItemStatusID {
    Unknown = 'unknown',
    NotDone = 'not-done',
    Done = 'done',
    NotCurrent = 'not-current',
    Current = 'current',
    Disabled = 'disabled',
  }

  export enum NavItemTypeID {
    InternalLink = '1',
    ExternalLink = '2',
  }
  
  export class NavItem {
    constructor(
        public name: string = '',
        public routeSecName: string = '',
        public routeQuery?: any,
        public visible: boolean = true,
        public status: NavItemStatus = NavItemStatusID.Unknown,
        public type: NavItemType = NavItemTypeID.InternalLink,
        public externalLink: string = ''
    ) {
    }
  }

  export type NavItemType = NavItemTypeID.InternalLink | NavItemTypeID.ExternalLink;
  export type NavItemStatus = NavItemStatusID.Unknown | NavItemStatusID.NotDone |
  NavItemStatusID.Done | NavItemStatusID.NotCurrent | NavItemStatusID.Current | NavItemStatusID.Disabled;
  
  